module.exports = __webpack_public_path__ + "img/3.314945a1.jpg";